import SoftButton from "components/SoftButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormField from "layouts/pages/roles-and-permissions/components/FormField";
import initialValues from "./schema/initialValues";
import form from "./schema/form";
import validation from "./schema/validation";
import { Form, Formik } from "formik";
import { useRoles } from "hooks/useRoles";
import { useRef } from "react";
import { updateUser } from "api/UserApi";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { UPDATE_USER } from "redux/constants/portal";
import { toast } from "react-toastify";

export const UserRoleDialog = ({ open, onClose, currentUser }) => {
   const {
      formField: { role }
   } = form;
   const { roles } = useRoles(false);
   const formRef = useRef(null);
   const { user } = useAuth0();
   const dispatch = useDispatch();

   const handleFormSubmit = async (values) => {
      const input = {
         ...currentUser,
         role_id: values.role
      };

      await updateUser(user.stripeId, input.auth0_id, input);

      input.tenant_id = user.stripeId;
      dispatch({
         type: UPDATE_USER,
         payload: input
      });

      toast.success("Role successfully updated");

      onClose();
   };

   const handleCreateDefaultRoleValue = () => {
      const foundRole = roles.find((role) => role.id === currentUser.role_id);

      return {
         value: foundRole?.id ?? "",
         label: foundRole?.name ?? ""
      };
   };

   const handleCreateRoleOptions = () => {
      return roles
         .filter((role) => role.name !== "Owner")
         .map((role) => ({
            value: role.id,
            label: role.name
         }));
   };

   return (
      <>
         <Dialog
            fullWidth={true}
            maxWidth={"sm"}
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
               style: {
                  overflow: "visible"
               }
            }}
         >
            <DialogTitle id="alert-dialog-title">Assign Role</DialogTitle>
            <DialogContent sx={{ overflow: "visible" }}>
               <DialogContentText id="alert-dialog-description">Choose a role that you want to assign to the user.</DialogContentText>

               <Formik initialValues={initialValues} validationSchema={validation} onSubmit={handleFormSubmit} innerRef={formRef}>
                  {({ errors, values }) => {
                     return (
                        <Form style={{ paddingTop: "1rem" }}>
                           <FormField
                              label="Role"
                              name="role"
                              defaultValue={handleCreateDefaultRoleValue()}
                              error={Boolean(errors[role.name])}
                              placeholder={role.placeholder ? role.placeholder : ""}
                              s
                              options={open ? handleCreateRoleOptions() : role.options}
                              menuPlacement="bottom"
                           />
                           <DialogActions>
                              <SoftButton onClick={onClose} variant="outlined" color="info" type="button">
                                 Cancel
                              </SoftButton>
                              <SoftButton variant="contained" color="info" type="submit" disabled={values.role === "" || values.role === currentUser.role_id}>
                                 Save
                              </SoftButton>
                           </DialogActions>
                        </Form>
                     );
                  }}
               </Formik>
            </DialogContent>
         </Dialog>
      </>
   );
};
